import React from 'react';
import {BreadcrumbLink} from "../../models/BreadcrumbLink";

interface BreadcrumbsProps {
    links: BreadcrumbLink[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ links }) => {
    return (
        <p id="path" className="clear">
            {links.map((link, index) => (
                <React.Fragment key={link.url}>
                    {index === links.length - 1 ? (
                        <strong>{link.text}</strong>
                    ) : (
                        <a href={link.url}>{link.text}</a>
                    )}
                    {index < links.length - 1 && <span> → </span>}
                </React.Fragment>
            ))}
        </p>
    );
};

export default Breadcrumbs;